import { content } from '@content';
import { OptionItem } from '@components/Menu/Option/Option.props';

export enum OptionsTypes {
  FILTER_BY = 'filterBy',
  SORT_BY = 'sortBy',
  DIVIDER = 'divider',
}

export enum FilterByValues {
  NONE = 'none',
  ONLY_RECENT = 'lastUsed', // 'lastUsed' maps to 'onlyRecent' filter
  NOT_IN_USE = 'notInUse',
}

export enum SortByValues {
  AUTHOR = 'author',
  CREATED = 'createdAt',
  LAST_USED = 'lastUsed',
  NAME = 'name',
  UPDATED = 'updatedAt',
}

export const FILTER_SORT_OPTIONS: OptionItem[] = [
  {
    id: '1',
    label: content.filterBy,
    subOptions: [
      {
        id: '2',
        type: OptionsTypes.FILTER_BY,
        label: content.none,
        value: FilterByValues.NONE,
        active: true,
      },
      // {
      //   id: '3',
      //   type: OptionsTypes.FILTER_BY,
      //   label: content.onlyRecent,
      //   value: FilterByValues.ONLY_RECENT,
      // },
      {
        id: '4',
        type: OptionsTypes.FILTER_BY,
        label: content.notInUse,
        value: FilterByValues.NOT_IN_USE,
      },
    ],
  },
  {
    id: '5',
    type: OptionsTypes.DIVIDER,
  },
  {
    id: '6',
    label: content.sortBy,
    subOptions: [
      {
        id: '7',
        type: OptionsTypes.SORT_BY,
        label: content.author,
        value: SortByValues.AUTHOR,
      },
      {
        id: '8',
        type: OptionsTypes.SORT_BY,
        label: content.createdDate,
        value: SortByValues.CREATED,
      },
      {
        id: '09',
        type: OptionsTypes.SORT_BY,
        label: content.lastDeployment,
        value: SortByValues.LAST_USED,
      },
      {
        id: '10',
        type: OptionsTypes.SORT_BY,
        label: content.lastUpdated,
        value: SortByValues.UPDATED,
        active: true,
      },
      {
        id: '11',
        type: OptionsTypes.SORT_BY,
        label: content.name,
        value: SortByValues.NAME,
      },
    ],
  },
];

export const ITEMS_PER_PAGE_FOR_SUGGESTIONS = 20;
